import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container media-page"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0,
  class: "container"
};
const _hoisted_5 = {
  class: "duration"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "pagination"
};
const _hoisted_10 = {
  class: "handle-box"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  class: "container"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = ["src"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  class: "pagination"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  key: 0,
  class: "music-player"
};
const _hoisted_21 = ["innerHTML"];
import { nextTick, onMounted, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat, formatTime, replaceImg, substr } from "@/utils/libs";
import { Search } from "@element-plus/icons-vue";
import MusicPlayer from "@/components/MusicPlayer.vue";
import Generating from "@/components/ui/Generating.vue";

// 变量定义

export default {
  __name: 'Medias',
  setup(__props) {
    const data = ref({
      suno: {
        items: [],
        query: {
          prompt: "",
          username: "",
          created_at: [],
          page: 1,
          page_size: 15
        },
        total: 0,
        page: 1,
        pageSize: 10,
        loading: true
      },
      luma: {
        items: [],
        query: {
          prompt: "",
          username: "",
          created_at: [],
          page: 1,
          page_size: 15
        },
        total: 0,
        page: 1,
        pageSize: 10,
        loading: true
      }
    });
    const activeName = ref("suno");
    const playList = ref([]);
    const playerRef = ref(null);
    const showPlayer = ref(false);
    const showLyricDialog = ref(false);
    const lyrics = ref("");
    const showVideoDialog = ref(false);
    const currentVideoUrl = ref("");
    onMounted(() => {
      fetchSunoData();
    });
    const handleChange = tab => {
      switch (tab) {
        case "suno":
          fetchSunoData();
          break;
        case "luma":
          fetchLumaData();
          break;
      }
    };

    // 搜索对话
    const search = (evt, tab) => {
      if (evt.keyCode === 13) {
        handleChange(tab);
      }
    };

    // 获取数据
    const fetchSunoData = () => {
      const d = data.value.suno;
      d.query.page = d.page;
      d.query.page_size = d.pageSize;
      httpPost("/admin/media/list/suno", d.query).then(res => {
        if (res.data) {
          d.items = res.data.items;
          d.total = res.data.total;
          d.page = res.data.page;
          d.pageSize = res.data.page_size;
        }
        d.loading = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    const fetchLumaData = () => {
      const d = data.value.luma;
      d.query.page = d.page;
      d.query.page_size = d.pageSize;
      httpPost("/admin/media/list/luma", d.query).then(res => {
        if (res.data) {
          d.items = res.data.items;
          d.total = res.data.total;
          d.page = res.data.page;
          d.pageSize = res.data.page_size;
        }
        d.loading = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    const remove = function (row, tab) {
      httpGet(`/api/admin/media/remove?id=${row.id}&tab=${tab}`).then(() => {
        ElMessage.success("删除成功！");
        handleChange(tab);
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    const playMusic = item => {
      playList.value = [item];
      showPlayer.value = true;
      nextTick(() => playerRef.value.play());
    };
    const playVideo = item => {
      currentVideoUrl.value = replaceImg(item.video_url);
      showVideoDialog.value = true;
    };
    const md = require("markdown-it")({
      breaks: true,
      html: true,
      linkify: true
    });
    const showLyric = item => {
      showLyricDialog.value = true;
      lyrics.value = md.render(item.prompt);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => activeName.value = $event),
        onTabChange: handleChange
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
          label: "Suno音乐",
          name: "suno"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
            modelValue: data.value.suno.query.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.value.suno.query.username = $event),
            placeholder: "用户名",
            class: "handle-input mr10",
            onKeyup: _cache[1] || (_cache[1] = $event => search($event, 'suno')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: data.value.suno.query.prompt,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.value.suno.query.prompt = $event),
            placeholder: "提示词",
            class: "handle-input mr10",
            onKeyup: _cache[3] || (_cache[3] = $event => search($event, 'suno')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: data.value.suno.query.created_at,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.value.suno.query.created_at = $event),
            type: "daterange",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            style: {
              "margin-right": "10px",
              "width": "200px",
              "position": "relative",
              "top": "3px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: fetchSunoData
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("搜索")])),
            _: 1
          }, 8, ["icon"])]), data.value.suno.items.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: data.value.suno.items,
              "row-key": row => row.id,
              "table-layout": "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "user_id",
                label: "用户ID"
              }), _createVNode(_component_el_table_column, {
                label: "歌曲预览"
              }, {
                default: _withCtx(scope => [scope.row.cover_url ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_image, {
                  src: scope.row.cover_url,
                  fit: "cover"
                }, null, 8, ["src"]), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatTime)(scope.row.duration)), 1), _createElementVNode("button", {
                  class: "play",
                  onClick: $event => playMusic(scope.row)
                }, _cache[21] || (_cache[21] = [_createElementVNode("img", {
                  src: "/images/play.svg",
                  alt: ""
                }, null, -1)]), 8, _hoisted_6)])) : (_openBlock(), _createBlock(_component_el_image, {
                  key: 1,
                  src: "/images/failed.jpg",
                  style: {
                    "height": "90px"
                  },
                  fit: "cover"
                }))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "title",
                label: "标题"
              }), _createVNode(_component_el_table_column, {
                prop: "progress",
                label: "任务进度"
              }, {
                default: _withCtx(scope => [scope.row.progress <= 100 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.progress) + "%", 1)) : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger"
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("已失败")])),
                  _: 1
                }))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "power",
                label: "消耗算力"
              }), _createVNode(_component_el_table_column, {
                prop: "tags",
                label: "风格"
              }), _createVNode(_component_el_table_column, {
                prop: "play_times",
                label: "播放次数"
              }), _createVNode(_component_el_table_column, {
                label: "歌词"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  plain: "",
                  onClick: $event => showLyric(scope.row)
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("查看歌词")])),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "创建时间"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "失败原因"
              }, {
                default: _withCtx(scope => [scope.row.progress === 101 ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top-start",
                  title: "失败原因",
                  width: 300,
                  trigger: "hover",
                  content: scope.row.err_msg
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_text, {
                    type: "danger"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(substr)(scope.row.err_msg, 20)), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["content"])) : (_openBlock(), _createElementBlock("span", _hoisted_8, "无"))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "180"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popconfirm, {
                  title: "确定要删除当前记录吗?",
                  onConfirm: $event => remove(scope.row, 'suno')
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_button, {
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("删除")])),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["onConfirm"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "row-key"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_9, [data.value.suno.total > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "total,prev, pager, next",
            "hide-on-single-page": true,
            "current-page": data.value.suno.page,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = $event => data.value.suno.page = $event),
            "page-size": data.value.suno.pageSize,
            "onUpdate:pageSize": _cache[6] || (_cache[6] = $event => data.value.suno.pageSize = $event),
            onCurrentChange: _cache[7] || (_cache[7] = $event => fetchSunoData()),
            total: data.value.suno.total
          }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])])) : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1
          }))]),
          _: 1
        })), [[_directive_loading, data.value.suno.loading]]), _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
          label: "Luma视频",
          name: "luma"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_input, {
            modelValue: data.value.luma.query.username,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.value.luma.query.username = $event),
            placeholder: "用户名",
            class: "handle-input mr10",
            onKeyup: _cache[9] || (_cache[9] = $event => search($event, 'sd')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: data.value.luma.query.prompt,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => data.value.luma.query.prompt = $event),
            placeholder: "提示词",
            class: "handle-input mr10",
            onKeyup: _cache[11] || (_cache[11] = $event => search($event, 'sd')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: data.value.luma.query.created_at,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => data.value.luma.query.created_at = $event),
            type: "daterange",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            style: {
              "margin-right": "10px",
              "width": "200px",
              "position": "relative",
              "top": "3px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: fetchLumaData
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("搜索")])),
            _: 1
          }, 8, ["icon"])]), data.value.luma.items.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: data.value.luma.items,
              "row-key": row => row.id,
              "table-layout": "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "user_id",
                label: "用户ID"
              }), _createVNode(_component_el_table_column, {
                label: "视频预览"
              }, {
                default: _withCtx(scope => [_createElementVNode("div", _hoisted_12, [scope.row.progress === 100 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("video", {
                  class: "video",
                  src: _unref(replaceImg)(scope.row.video_url),
                  preload: "auto",
                  loop: "loop",
                  muted: "muted"
                }, "您的浏览器不支持视频播放", 8, _hoisted_14), _createElementVNode("button", {
                  class: "play",
                  onClick: $event => playVideo(scope.row)
                }, _cache[26] || (_cache[26] = [_createElementVNode("img", {
                  src: "/images/play.svg",
                  alt: ""
                }, null, -1)]), 8, _hoisted_15)])) : scope.row.progress > 100 ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 1,
                  src: scope.row.cover_url,
                  fit: "cover"
                }, null, 8, ["src"])) : (_openBlock(), _createBlock(Generating, {
                  key: 2,
                  message: "正在生成视频"
                }))])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "progress",
                label: "任务进度"
              }, {
                default: _withCtx(scope => [scope.row.progress <= 100 ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(scope.row.progress) + "%", 1)) : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger"
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode("已失败")])),
                  _: 1
                }))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "power",
                label: "消耗算力"
              }), _createVNode(_component_el_table_column, {
                label: "提示词"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popover, {
                  placement: "top-start",
                  title: "提示词",
                  width: 300,
                  trigger: "hover",
                  content: scope.row.prompt
                }, {
                  reference: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_unref(substr)(scope.row.prompt, 20)), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "创建时间"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "失败原因"
              }, {
                default: _withCtx(scope => [scope.row.progress === 101 ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top-start",
                  title: "失败原因",
                  width: 300,
                  trigger: "hover",
                  content: scope.row.err_msg
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_text, {
                    type: "danger"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(substr)(scope.row.err_msg, 20)), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["content"])) : (_openBlock(), _createElementBlock("span", _hoisted_17, "无"))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "180"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popconfirm, {
                  title: "确定要删除当前记录吗?",
                  onConfirm: $event => remove(scope.row, 'luma')
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_button, {
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("删除")])),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["onConfirm"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "row-key"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_18, [data.value.luma.total > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "total,prev, pager, next",
            "hide-on-single-page": true,
            "current-page": data.value.luma.page,
            "onUpdate:currentPage": _cache[13] || (_cache[13] = $event => data.value.luma.page = $event),
            "page-size": data.value.luma.pageSize,
            "onUpdate:pageSize": _cache[14] || (_cache[14] = $event => data.value.luma.pageSize = $event),
            onCurrentChange: _cache[15] || (_cache[15] = $event => fetchLumaData()),
            total: data.value.luma.total
          }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])])) : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1
          }))]),
          _: 1
        })), [[_directive_loading, data.value.luma.loading]])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: showVideoDialog.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => showVideoDialog.value = $event),
        title: "视频预览"
      }, {
        default: _withCtx(() => [_createElementVNode("video", {
          style: {
            "width": "100%",
            "max-height": "90vh"
          },
          src: currentVideoUrl.value,
          preload: "auto",
          autoplay: true,
          loop: "loop",
          muted: "muted"
        }, " 您的浏览器不支持视频播放 ", 8, _hoisted_19)]),
        _: 1
      }, 8, ["modelValue"]), showPlayer.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(MusicPlayer, {
        songs: playList.value,
        ref_key: "playerRef",
        ref: playerRef,
        "show-close": true,
        onClose: _cache[18] || (_cache[18] = $event => showPlayer.value = false)
      }, null, 8, ["songs"])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: showLyricDialog.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => showLyricDialog.value = $event),
        title: "歌词"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "chat-line",
          innerHTML: lyrics.value
        }, null, 8, _hoisted_21)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};